import { QuoteRoutes } from '../../../main/constants'
import { StatsQuery } from '../../stats/types'
import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-compare-perf-link a')

export default function ComparePerfLink() {
  const isPremium = window.FinvizSettings.hasUserPremium
  const currentTimeframePath = useChartTimeframePathWatch()
  if (!currentTimeframePath)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Compare Perf.
      </a>
    )

  const newURL = new URL(currentTimeframePath, window.location.origin)
  newURL.searchParams.set(StatsQuery.ChartType, QuoteRoutes.Performance)

  return (
    <a
      href={
        isPremium
          ? `${newURL.pathname}${newURL.search}`
          : `/elite.ashx?utm_source=finviz&utm_medium=banner&utm_campaign=quote-compare-perf`
      }
      className="tab-link"
      data-testid="quote-compare-perf-link"
    >
      Compare Perf.
    </a>
  )
}
